<template>
  <b-container>
    <template v-if="has_KiidOrSid || !isPureMop">
      <b-row class="mt-4 mb-4">
        <b-col cols="12">
          <div class="underlying-details p-3">
            <div class="font-weight-bold border-underlying mb-3">
              <p>{{ title }}</p>
            </div>
            <div v-if="isMop">
              <b-tabs @input="indexCurrentTab" class="fairmat-secondary-tabs mb-4">
                <b-tab active lazy>
                  <template v-slot:title> {{ $t('common.typology') }}</template>
                  <highcharts class="mt-4" :options="investmentOptions"></highcharts>
                </b-tab>
                <b-tab>
                  <template v-slot:title> {{ $t('common.category') }}</template>
                  <highcharts class="mt-4" :options="investmentOptions"></highcharts>
                </b-tab>
              </b-tabs>
            </div>
            <div v-else>
              <p class="mb-0">
                <span class="font-weight-bold">{{ $t('common.typology') }}:</span>
                {{ $t('search.filterSelectValues.optionUnderlyingType.' + getUnderlyingType) }}
              </p>
              <p class="mb-0" v-if="getUnderlyingType === 1">
                <span class="font-weight-bold">{{ $t('common.isin') }}:</span>
                {{ getUnderlyingIsin }}
              </p>
              <p>
                <span class="font-weight-bold">{{ $t('common.category') }}:</span>
                {{ $t('search.filterSelectValues.optionFundCategory.' + getFundCategory) }}
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
  </b-container>
</template>

<script>
export default {
  props: {
    value: {},
    title: String,
    isMop: {
      type: Boolean,
      default: false,
    },
    kidType: {
      type: Number,
    },
    nOfFundCategoryOptions: {},
    nOfFundCategoryOptionsKiid: {},
    nOfUnderlyingTypeOptions: {},
    nOfUnderlyingTypeOptionsKiid: {},
  },

  data() {
    return {
      currentTabSelected: 0,
    }
  },

  methods: {
    indexCurrentTab(index) {
      this.currentTabSelected = index
    },
  },

  computed: {
    has_KiidOrSid() {
      let count = 0
      if (this.nOfFundCategoryOptions) {
        this.nOfFundCategoryOptions.forEach((element) => {
          if (element) {
            count += element
          }
        })
      }

      if (this.nOfFundCategoryOptionsKiid) {
        this.nOfFundCategoryOptionsKiid.forEach((element) => {
          if (element) {
            count += element
          }
        })
      }

      return count > 0
    },
    getUnderlyingIsin() {
      return this.value == null ? '-' : this.value.isin
    },
    getUnderlyingType() {
      return this.value == null ? '0' : this.value.underlyingType
    },
    getFundCategory() {
      return this.value == null ? '0' : this.value.fundCategory
    },
    isPureMop() {
      return this.kidType === 1
    },
    investmentOptions: function () {
      const that = this
      return {
        chart: {
          type: 'column',
          backgroundColor: 'transparent',
          margin: [null, null, 5, null],
          height: '50%',
          paddingBotton: '30px',
          events: {
            render: function () {
              this.series[0].data.map((val) => (val.y === 0 ? val.update({ y: -0.001 }) : null))
            },
          },
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            minPointLength: 3,
            point: {
              events: {
                click: function (event) {
                  that.$emit('underlying-type-click', {
                    currentTabSelected: that.currentTabSelected,
                    underlyingType: event.point.category,
                    optionUnderlyingKey: null,
                    type: event.point.series.name,
                  })
                },
              },
            },
            events: {
              legendItemClick: function () {
                return false
              },
            },
          },
          column: {
            maxPointWidth: 40,
            dataLabels: {
              enabled: true,
              verticalAlign: 'bottom',
              align: 'left',
              y: -5,
              rotation: -90,
              inside: true,
              formatter() {
                return this.x
              },
              style: {
                textOutline: null,
                textOverflow: 'ellipsis',
                fontWeight: null,
                color: 'black',
              },
            },
            states: {
              inactive: {
                opacity: 1,
              },
            },
          },
        },
        exporting: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        labels: {
          enabled: false,
        },
        xAxis: {
          categories:
            this.currentTabSelected === 1
              ? Object.values(this.filterSelectValues.optionFundCategory)
              : Object.values(this.filterSelectValues.optionUnderlyingType),
        },
        yAxis: {
          min: 0,
          allowDecimals: false,
          title: { text: this.$t('productDetails.numberOfOptions') },
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
          itemStyle: { cursor: 'default' },
        },
        title: {
          text: null,
        },
        series: [
          {
            data: this.currentTabSelected === 1 ? this.nOfFundCategoryOptions : this.nOfUnderlyingTypeOptions,
            borderColor: 'secondary',
            color: '#4A87C3',
            name: 'SID',
          },
          {
            data: this.currentTabSelected === 1 ? this.nOfFundCategoryOptionsKiid : this.nOfUnderlyingTypeOptionsKiid,
            color: '#A2CAF0',
            borderColor: 'secondary',
            name: 'KIID',
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.underlying-details {
  border: 1px solid var(--gray8);
  border-radius: 0.2rem;
  overflow: hidden;
}

.border-underlying {
  border-bottom: 2px solid var(--secondaryBGColor);
}
</style>
